(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var els = document.querySelectorAll('.delivery-date-inline[data-delivery-days]');
    if (!els.length) return;

    els.forEach(function(el) {
      var daysAttr = el.getAttribute('data-delivery-days');
      var days = parseInt(daysAttr, 10);
      if (isNaN(days)) return;

      var sameDay = days === 0;
      var today = new Date();
      var start = new Date(today);

      if (!sameDay) {
        start.setDate(start.getDate() + 1);
      }

      var end = new Date(start);

      if (!sameDay) {
        // Window length equals selected days (e.g. 5 -> 5‑day window)
        end.setDate(end.getDate() + (days - 1));
      }

      // HIER IS DE AANPASSING: 'nl-NL' toegevoegd voor Nederlandse taal
      var options = { month: 'long', day: 'numeric' };
      var startText = start.toLocaleDateString('nl-NL', options);
      var endText = end.toLocaleDateString('nl-NL', options);

      el.textContent = sameDay ? startText : (startText + ' - ' + endText);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
